import React from 'react';
import Illustration, { IllustrationProps } from './Illustration';

const EmptyStateSvg: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return (
        <svg
            width="1000"
            height="1000"
            viewBox="0 0 1000 1000"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect
                x="102.715"
                y="530.352"
                width="577.48"
                height="418.727"
                fill="#CED4DA"
            />
            <path
                d="M680.194 530.352V949.079"
                stroke="#000216"
                strokeWidth="3"
            />
            <rect
                x="166.734"
                y="385"
                width="449.623"
                height="449.623"
                fill="#3F00FF"
            />
            <path
                d="M196.478 673.846L191.342 656.587C183.223 629.299 158.137 610.59 129.666 610.59H2L102.715 949.081H680.196L598.302 673.846H196.478Z"
                fill="#E9ECEF"
            />
            <path
                d="M102.715 949.079H680.195"
                stroke="#000216"
                strokeWidth="3"
            />
            <path
                d="M680.191 949.079L598.297 673.843H196.473"
                stroke="#000216"
                strokeWidth="3"
            />
            <rect
                x="226.984"
                y="444.709"
                width="331.647"
                height="87.2754"
                fill="#EFF4FF"
                stroke="#EFF4FF"
                strokeWidth="2"
            />
            <rect
                width="26.9773"
                height="26.9773"
                transform="matrix(1 0 0 -1 798.27 345.607)"
                fill="#000216"
            />
            <rect
                width="26.9773"
                height="26.9773"
                transform="matrix(1 0 0 -1 884.789 345.607)"
                fill="#000216"
            />
            <rect
                width="26.9773"
                height="26.9773"
                transform="matrix(1 0 0 -1 971.316 345.607)"
                fill="#000216"
            />
            <path
                d="M734.648 334.912L668.315 402.264V334.912H734.648Z"
                fill="#E9ECEF"
            />
            <rect
                width="438.878"
                height="294.609"
                transform="matrix(-1 0 0 1 998.293 51)"
                fill="#E9ECEF"
            />
            <rect
                width="26.9773"
                height="26.9773"
                transform="matrix(-1 0 0 1 878.867 184.814)"
                fill="#3F00FF"
            />
            <rect
                width="26.9773"
                height="26.9773"
                transform="matrix(-1 0 0 1 792.344 184.814)"
                fill="#3F00FF"
            />
            <rect
                width="26.9773"
                height="26.9773"
                transform="matrix(-1 0 0 1 705.82 184.814)"
                fill="#3F00FF"
            />
            <line
                x1="226.984"
                y1="575.594"
                x2="558.631"
                y2="575.594"
                stroke="#EFF4FF"
                strokeWidth="2"
            />
            <line
                x1="226.984"
                y1="624.08"
                x2="558.631"
                y2="624.08"
                stroke="#EFF4FF"
                strokeWidth="2"
            />
        </svg>
    );
};

const EmptyState: React.FC<IllustrationProps> = (props) => (
    <Illustration component={EmptyStateSvg} {...props} />
);

export default EmptyState;
